import { useRouter } from "expo-router";

import { EligibilityScreenLayout } from "@/blocks/EligibilityScreenLayout";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnCard } from "@/components/VnCard";
import { VnText } from "@/components/VnText/VnText";

export const RecheckEligibilityScreen = () => {
  const router = useRouter();

  const goToNextStep = () => {
    router.navigate("/eligibility/household-income");
  };

  return (
    <EligibilityScreenLayout shouldShowBackButton={false}>
      <VnCard>
        <VnText
          i18nKey="native:recheckEligibilityScreen.title"
          variant="lgBold"
        />
      </VnCard>
      <VnButton
        i18nKey="native:recheckEligibilityScreen.button"
        onPress={goToNextStep}
      />
    </EligibilityScreenLayout>
  );
};
